<app-page-breadcrumb pageTitle="Plantillas de Contenido"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controls -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Productos/servicios y términos predefinidos para generar cotizaciones reutilizables.
    </p>

    <button type="button" (click)="nuevaPlantilla()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      Nueva Plantilla
    </button>
  </div>

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando plantillas...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Table -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Descripción</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Ítems</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Aprobación</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Activa</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Creada</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (templates.length === 0) {
          <tr>
            <td colspan="7" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                  </path>
                </svg>
                <span>No hay plantillas de contenido registradas</span>
              </div>
            </td>
          </tr>
          }

          @for (template of templates; track template.id) {
          <tr>
            <td class="px-4 py-3 text-start text-theme-sm">
              <span class="font-medium text-gray-800 dark:text-white/90">{{ template.name }}</span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="max-w-[260px] truncate block" [title]="template.description || ''">
                {{ template.description || '—' }}
              </span>
            </td>
            <td class="px-4 py-3 text-center text-theme-sm">
              <span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-blue-light-100 text-blue-light-700 dark:bg-blue-light-900/30 dark:text-blue-light-400">
                {{ itemCount(template) }}
              </span>
            </td>
            <td class="px-4 py-3 text-start text-theme-sm">
              @if (template.approvalRequired) {
              <span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-warning-100 text-warning-700 dark:bg-warning-900/30 dark:text-warning-400">
                Requiere
              </span>
              } @else {
              <span class="text-gray-400 dark:text-gray-600 text-sm">No</span>
              }
            </td>
            <td class="px-4 py-3 text-start text-theme-sm">
              @if (template.isActive) {
              <span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-400">
                Activa
              </span>
              } @else {
              <span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                Inactiva
              </span>
              }
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ formatDate(template.datetimeCreated) }}
            </td>
            <td class="px-4 py-3 text-center text-theme-sm">
              <div class="flex items-center justify-center gap-1">
                <!-- Generate quote -->
                <button (click)="generarCotizacion(template)"
                  class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                  title="Generar cotización">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01">
                    </path>
                  </svg>
                </button>

                <!-- Edit -->
                <button (click)="editarPlantilla(template)"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors" title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>

                <!-- Delete (requiere rol Admin; el backend responde 403 para el resto) -->
                @if (canDelete) {
                <button (click)="eliminarPlantilla(template)"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 dark:hover:bg-error-900/20 dark:hover:text-error-400 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
                }
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>

<!-- Generate quote modal -->
@if (showGenerateModal) {
<div class="fixed inset-0 z-modal flex items-center justify-center bg-black/40" (click)="closeGenerateModal()">
  <div class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">Generar cotización</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
      Selecciona el negocio (deal) al que pertenecerá la cotización generada desde
      <span class="font-medium text-gray-700 dark:text-gray-300">"{{ generateTemplate?.name }}"</span>.
    </p>

    <app-entity-picker
      label="Negocio"
      placeholder="Buscar negocio... (Enter para ver todos)"
      helperText="La cotización generada quedará asociada a este negocio."
      [selectedId]="selectedDeal?.id ?? null"
      [selectedLabel]="selectedDeal?.label ?? null"
      [searchFn]="searchDeals"
      (selectionChange)="onDealSelected($event)" />

    <!-- Contacto principal (opcional) -->
    <div class="mt-4">
      <app-entity-picker
        label="Contacto principal (opcional)"
        placeholder="Buscar contacto... (Enter para ver todos)"
        helperText="Se autocompleta con el contacto principal del negocio; puedes cambiarlo."
        [selectedId]="selectedContact?.id ?? null"
        [selectedLabel]="selectedContact?.label ?? null"
        [selectedSublabel]="selectedContact?.sublabel ?? null"
        [autoFilledFlash]="contactAutoFilled"
        [searchFn]="searchContacts"
        (selectionChange)="onContactSelected($event)" />
    </div>

    <!-- Moneda (opcional) -->
    <div class="mt-4">
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Moneda (opcional)</label>
      <select [(ngModel)]="selectedCurrencyId" (change)="onCurrencyManuallyChanged()"
        class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="null">— Heredar la moneda del negocio —</option>
        @for (c of currencies; track c.id) {
        <option [ngValue]="c.id">{{ c.prefix || c.code }} · {{ c.name }}</option>
        }
      </select>
    </div>

    <!-- Plantilla de branding (opcional) -->
    <div class="mt-4">
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Plantilla de branding (opcional)</label>
      <select [(ngModel)]="selectedBrandingTemplateId"
        class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="null">— Usar la plantilla predeterminada —</option>
        @for (t of brandingTemplates; track t.id) {
        <option [ngValue]="t.id">{{ t.name }}{{ t.isDefault ? ' (predeterminada)' : '' }}</option>
        }
      </select>
    </div>

    <div class="flex justify-end gap-2 mt-6">
      <button type="button" (click)="closeGenerateModal()" [disabled]="generating"
        class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 disabled:opacity-50">
        Cancelar
      </button>
      <button type="button" (click)="confirmarGenerar()" [disabled]="!selectedDeal || generating"
        class="px-4 py-2 text-sm rounded-md bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 flex items-center gap-2">
        @if (generating) {
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        Generando...
        } @else {
        Generar cotización
        }
      </button>
    </div>
  </div>
</div>
}
